<template>
  <measurements-index-list
    :state="PersonMeasurements"
    :edit="edit"
    :period="period"
    :dateFrom="dateFrom"
    :dateTo="dateTo"
    :meta="meta">
  </measurements-index-list>
</template>

<script>
import MeasurementsIndexList from './cmpt-measurements-index-list';

export default {
  name: 'page-evolution-measurements-list',
  props: {
    id: {
      required: true,
      default: null,
    },
    meta: {
      required: true,
      default: null,
    },
    edit: {
      required: false,
      default: false,
    },
    period: {
      required: false,
      default: null,
    },
    dateFrom: {
      required: false,
      default: null,
    },
    dateTo: {
      required: false,
      default: null,
    },
  },
  components: {
    MeasurementsIndexList,
  },
  computed: {
    PersonDetails() {
      return this.$store.getters.PersonDetails(this.id);
    },
    PersonMeasurements() {
      return this.$store.getters.PersonMeasurements(this.id);
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/pages/professional/persons/participants/participant-evolution/dashboard/page-evolution-measurements-list.vue